import { render, staticRenderFns } from "./VabThemeDrawer.vue?vue&type=template&id=5f7147d2"
import script from "./VabThemeDrawer.vue?vue&type=script&lang=js"
export * from "./VabThemeDrawer.vue?vue&type=script&lang=js"
import style0 from "./VabThemeDrawer.vue?vue&type=style&index=0&id=5f7147d2&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7147d2')) {
      api.createRecord('5f7147d2', component.options)
    } else {
      api.reload('5f7147d2', component.options)
    }
    module.hot.accept("./VabThemeDrawer.vue?vue&type=template&id=5f7147d2", function () {
      api.rerender('5f7147d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabTheme/components/VabThemeDrawer.vue"
export default component.exports